module.exports = __webpack_public_path__ + "static/media/correctYes.bf7a083c.mp3";